function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrowW8 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8 8"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h8v8H0z",
  style: {
    fill: "transparent"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m347.277 506.812 3.2 3.2-3.2 3.2",
  "data-name": "Path 472",
  style: {
    fill: "none",
    stroke: "#acacac",
    strokeLinejoin: "round"
  },
  transform: "translate(-345 -506.012)"
}));
export default SvgIconArrowW8;